<div [ngClass]="'header header-' + theme">
  <div *ngIf="theme === 'e-learning' && innerWidth < 768" class="header-empty-div" [ngStyle]="{ display: centerLogo ? 'block' : 'none' }"></div>
  
  <!-- Logo affiché sauf si on est sur mobile ET dans une page avec menu burger -->
  <div *ngIf="!(showBurgerMenu && innerWidth < 768)" class="logo">
    <a href="/home" target="_parent">
      <img src="../../../../assets/images/MMA_LOGO_JAUNE_RVB_couronne.svg" />
    </a>
  </div>
  
  <span class="demo-mode" *ngIf="demo">MODE DEMO</span>
  <div class="links-and-profile">
    <a class="redirection-link" href="/home" target="_parent">Mon espace</a>
    <app-profile-minified></app-profile-minified>
  </div>
</div>